import {
  FILEUPLOAD_UPLOAD_FILE_BEGIN,
  FILEUPLOAD_UPLOAD_FILE_SUCCESS,
  FILEUPLOAD_UPLOAD_FILE_FAILURE,
  FILEUPLOAD_UPLOAD_FILE_DISMISS_ERROR,
} from './constants';

import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';


// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function uploadFile(file,type,args = {}) {
  let archivo = new FormData();
  archivo.append('file',file);
  
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: FILEUPLOAD_UPLOAD_FILE_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let route=""
      if(type===1){
        route="/deliverables/uploadCsv"
      }else if(type===2){
        route="/currencies/uploadCsv"
      }else if(type===3){
        route="/units/uploadCsv"
      }else if(type===4){
        route="/phases/uploadCsv"
      }
      let URL = SERVER_PATH + route;
      axios.post(URL,archivo,AXIOS_CONFIG())
      .then(
        (res) => {
          dispatch({
            type: FILEUPLOAD_UPLOAD_FILE_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: FILEUPLOAD_UPLOAD_FILE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissUploadFileError() {
  return {
    type: FILEUPLOAD_UPLOAD_FILE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FILEUPLOAD_UPLOAD_FILE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        uploadFilePending: true,
        uploadFileError: null,
      };

    case FILEUPLOAD_UPLOAD_FILE_SUCCESS:
      // The request is success
      return {
        ...state,
        uploadFilePending: false,
        uploadFileError: null,
        loadingFile:false,
      };

    case FILEUPLOAD_UPLOAD_FILE_FAILURE:
      // The request is failed
      return {
        ...state,
        uploadFilePending: false,
        uploadFileError: action.data.error,
        loadingFile:false,
      };

    case FILEUPLOAD_UPLOAD_FILE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        uploadFileError: null,
        loadingFile:false,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/fileupload/redux/uploadFile.js